import React from "react";
import { Spinner } from "../assets/svg/Spinner";

export const Loader = () => (
  <div role="status" data-testid="loading-spinner">
    <Spinner />
    <span className="sr-only">Loading...</span>
  </div>
);
